import { argumentTypesPath, taskTemplatesPath } from './registry.js';
// import { siteConfigRef } from './SiteConfig.js';
import { getShared } from './Utils.js';
import { makeSimFirestore, setMeta } from '../ui_sim/SimClient/SimClientLib.js';
import { getUnitWp, argPublish, argSubscribe, getMappedRobots, safeGetRobotId } from './lib.js';
import { getConfig } from '../utils/configUtils';
import sleep from 'sleep-promise';
import { getRobotDisplayName } from '../utils/textUtils';
import {setUseFirestore} from '../constants//Meta';

import firebase from 'firebase';

export var authToken = '';

let fsLoggedIn = false;

export let removedConfigWaypoints;
class MoxiTaskEnv {
  /**
   * Moxi task environment object that stores sdk configuration and handles chime suppression logic.
   */
  constructor() {
    this.SUPPRESS_CHIME_FOR_MS = 20000;
    this.lastNotifTickCount = 0;
    this.lastSeenTimeTickCount = 0;
    if (!MoxiTaskEnv.instance) {
      this.host = undefined;
      this.site = undefined;
      this.siteConfig = undefined;
      this.kiosk = undefined;
      this.firestore = undefined;
      this.argumentTypes = undefined;
      this.configs = undefined;
      MoxiTaskEnv.instance = this;
    }

    return MoxiTaskEnv.instance;
  }

  async authenticate(username, password) {
    await firebase.default.auth().signInWithEmailAndPassword(username, password);
    authToken = await firebase.default.auth().currentUser.getIdToken();
  }

  //TODO LMR: handle .currentUser being null/falsey (observed in field) by throwing explicit error
  async refreshToken() {
    await firebase.default
      .auth()
      .currentUser.getIdToken(true)
      .then((token) => (authToken = token));
  }

  msSinceLastNotif() {
    return Date.now() - this.lastNotifTickCount;
  }

  _shouldSuppressNotif() {
    return this.msSinceLastNotif() <= this.SUPPRESS_CHIME_FOR_MS;
  }

  _updateLastNotif() {
    this.lastNotifTickCount = Date.now();
  }

  _updateLastSeenTime(timestamp) {
    this.lastSeenTimeTickCount = new Date(timestamp).getTime();
  }

  _timeNeverSeen(timestamp) {
    return new Date(timestamp).getTime() > this.lastSeenTimeTickCount;
  }

  getSuppressPeriodMs() {
    return this.SUPPRESS_CHIME_FOR_MS;
  }

  handleChimeRequest(requestTimestamp, playChime) {

    if(getShared().autoPrioConfig?.noChimeThrottle) {
      playChime();
      return;
    }

    const notifSentAgo = Date.now() - new Date(requestTimestamp).getTime();
    if (
      notifSentAgo <= this.SUPPRESS_CHIME_FOR_MS &&
      !this._shouldSuppressNotif() &&
      this._timeNeverSeen(requestTimestamp)
    )
    {
      playChime();
      this._updateLastNotif();
    }

    this._updateLastSeenTime(requestTimestamp);
  }
}

// Shared MoxiTaskEnv instance
export const env = new MoxiTaskEnv();

// async function loadSiteConfig(firestore, site) {
//   const siteConfigDoc = await siteConfigRef(firestore, site).get();

//   if (siteConfigDoc.exists) {
//     return siteConfigDoc.data();
//   }
//   else {
//     console.log('Site Config doc not found!');
//   }

//   return undefined;
// }

// async function getArgTypes(firestore, site) {
//   let doc = await firestore.collection(site).doc('argument_types').get();
//   let collections = doc.data().collections;
//   let argTypes = {};
//   for (var argType of collections) {
//     argTypes[argType] = {};
//     var snapshot = await firestore.collection(argumentTypesPath(site, argType)).get();
//     for (var groupDoc of snapshot.docs) {
//       argTypes[argType][groupDoc.id] = groupDoc.data();
//     }
//   }

//   return argTypes;
// }

function subscribeToArguments(firestore, site) {
  // update if waypoints are edited
  // firestore
  //   .collection(site)
  //   .doc('argument_types/ids/mox_spots')
  //   .onSnapshot(async (doc) => {
  //     let argTypes = await getArgTypes(firestore, site);
  //     argPublish(argTypes);
    // });

  let argTypes = {ids:{}, waypoints:{}};
  const doPub = () => {
    if(argTypes.ids.mox_spots && argTypes.ids.robots && argTypes.waypoints.mox_spots)
      argPublish(argTypes);
  };

  firestore.collection(site).doc('argument_types/ids/mox_spots').onSnapshot(doc => { argTypes.ids.mox_spots = doc.data(); doPub(); });
  firestore.collection(site).doc('argument_types/ids/robots').onSnapshot(doc => { argTypes.ids.robots = doc.data(); doPub(); });
  firestore.collection(site).doc('argument_types/waypoints/mox_spots').onSnapshot(doc => { argTypes.waypoints.mox_spots = doc.data(); doPub(); });
}

async function loadInitialArguments(firestore, site) {
  // loads initial arguments and prepares subscription
  let argTypes;
  let unsubscribe = argSubscribe((argTypesParam) => (argTypes = argTypesParam));
  subscribeToArguments(env.firestore, env.site);

  let start = Date.now();
  while (!argTypes) {
    if (Date.now() - start > 1000 * 20)
      throw new Error('loadInitialArguments: timed out reading firestore argument_types');
    await sleep(250);
  }
  unsubscribe();
  return argTypes; // to set in env initially
}

let firebaseInited = false;


/**
 * Logs in user to firestore and load firestore configuration
 *
 * @param {str} username - firestore username
 * @param {str} password - firestore password
 */
export async function login(username, password, noFS) {
  const config = getConfig();
  env.site = config.site.mnem;

  setUseFirestore(!noFS);

  const getAutoPrioConfig = () => getShared().autoPrioConfig;
  const getBotMxPollTOTicks = () => {
    if(!safeGetRobotId()) return;
    let timeoutSeconds = getAutoPrioConfig()?.botMxPollTOSecs;
    return timeoutSeconds ? (timeoutSeconds * 1000) : undefined;
  };
  const getBotMxAddTOTicks = () => {
    if(!safeGetRobotId()) return;
    let timeoutSeconds = getAutoPrioConfig()?.botMxAddTOSecs;
    return timeoutSeconds ? (timeoutSeconds * 1000) : undefined;
  };
  let accessors = {safeGetRobotId, getAutoPrioConfig, getBotMxPollTOTicks, getBotMxAddTOTicks};

  if(noFS) {
    //codepaths here for both sim and production

    if(config.firestore.simServer) {
      //sim
      env.firestore = makeSimFirestore(config.firestore, accessors);
    }
    else {
      //non-sim; we're either running non-locally, or are pointed at a non-local site.

      // diligentApiHost: "http://127.0.0.1:3200/api/v1"
      // projectId: "sim-staging-datastore"
      // simServer: "http://127.0.0.1:3200"
      // siteName: "sim"

      config.nonLocal = true;
      let mbotFirestore = { ...config.firestore, simServer: config.uiSimServer }; //route firestore subscriptions to noFS backend
      env.firestore = makeSimFirestore(mbotFirestore, accessors);
    }
  }
  else if (config.firestore.simServer) {
    env.firestore = makeSimFirestore(config.firestore, accessors);
  }
  else {

    if (!firebaseInited) {
      firebase.default.initializeApp(config.firestore);
      firebaseInited = true;
    }

    env.firestore = firebase.default.firestore();

    if (config.firestore.diligent__EmulatorIp) {
      // If we are using emulator, do a little bit of extra config
      let host = `${config.firestore.diligent__EmulatorIp}:8080`;
      env.firestore.settings({ host, ssl: false });

      if (!env.host) env.host = 'http://' + host; //added this; getting away from configureEnvironment
    }
    else {
      // We only log in if we're not using the emulator
      await env.authenticate(username, password);
    }
  }

  // env.siteConfig = await loadSiteConfig(env.firestore, env.site);
  let argTypes = await loadInitialArguments(env.firestore, env.site);

  //The keys to ids.mox_spots and waypoints.mox_spots should be the same set.
  let counts = {};
  Object.keys(argTypes.ids.mox_spots).forEach((k) => (counts[k] = (counts[k] || 0) + 1));
  Object.keys(argTypes.waypoints.mox_spots).forEach((k) => (counts[k] = (counts[k] || 0) + 1));
  let keysToRemove = Object.keys(counts).filter((k) => counts[k] != 2);

  if (keysToRemove.length) {
    console.log('Incoherent mox_spots: ' + keysToRemove.join(', '));

    keysToRemove = keysToRemove.filter((k) => argTypes.ids.mox_spots[k]); //for now, only the ones in the unit menu
    // keysToRemove.forEach(k => {delete argTypes.ids.mox_spots[k]; delete argTypes.waypoints.mox_spots[k];});
    keysToRemove.forEach((k) => {
      delete argTypes.ids.mox_spots[k];
    }); //for now, just delete them from here, rather than from both

    if (!keysToRemove.length) keysToRemove = undefined;

    removedConfigWaypoints = keysToRemove;
  }
  else {
    console.log('mox_spots passed coherence check.');
  }
  fsLoggedIn = true;
}

getShared()['settings'] = {
  getEnv: () => env,
  getAuthToken: () => authToken,
};

export function setEnvInfo(diligentApiHost) {
  env.host = diligentApiHost;

  env.drawerInfo = {
    small: 'This is the smallest drawer.',
    medium: 'This is a medium-sized drawer.',
    large: 'This is the largest drawer.',
  };
}


export function isFSLoggedIn() {
  return fsLoggedIn;
}
